import { apiClient } from "../HttpClient";
import { API_GET_GUEST_OTP, API_CHECK_IN } from "../config";

export const getGuestOtp = async (): Promise<{ permanent_otp: string }> => {
  try {
    const client = await apiClient;
    const response = await client.get<{ permanent_otp: string }>(API_GET_GUEST_OTP);
    return response;
  } catch (error) {
    throw error;
  }
};

export const checkInGuest = async (bookingId: string, otp: string): Promise<any> => {
  try {
    const client = await apiClient;
    const response = await client.post<any>(API_CHECK_IN, { order_id: bookingId, otp: otp });
    return response;
  } catch (error) {
    throw error;
  }
};